module.controller(
		'areaDetailCtrl',
		[ '$scope', '$rootScope', '$state', 'clientService', 'alertService', 
		  function($scope, $rootScope, $state, clientService, alertService) {


			$scope.validation = {
					description : {
						maxlength : 500
					}				
			};

			$scope.operationType = $state.current.data.type;
			$scope.idClient = $state.params.idClient;
			$scope.idSite = $state.params.idSite;
			$scope.idArea = $state.params.idArea;
			$scope.area = {
					type: {}
			};
			$scope.loading = false;

			/**
			 * 
			 */
			 $scope.load = function(idClient, idSite, idArea) {
				 $scope.loading = true;

				 clientService.getClientArea(idClient, idSite, idArea).then(function(response) {
					 $scope.loading = false;

					 var responseData = response.getData();
					 $scope.area = {
							 type: {
								 selected: [{
									 id: responseData.type.id,
									 name: responseData.type.name,
									 value: responseData.type.value
								 }]
							 },
							 name: responseData.name,
							 description: responseData.description
					 };

				 }, function(response) {
					 $scope.loading = false;
				 });
			 };

			 /**
			  *
			  */
			 $scope.sendAction = function() {
				 if ($scope.operationType == 'create') {
					 $scope.create();
				 } else {
					 $scope.update();
				 }
			 };

			 /**
			  *
			  */
			 $scope.create = function() {
				 alertService.showSwtQuestion('Crear Área', function() {
					 $scope.loading = true;

					 var createModel = {
							 name: $scope.area.name,
							 description: $scope.area.description,
							 idType: $scope.area.type.selected[0].id
					 };

					 clientService.createClientArea($scope.idClient, $scope.idSite, createModel).then(function(response) {
						 $scope.loading = false;
						 alertService.showSuccess('Área creada satisfactoriamente');
						 $state.go('home.clientAreas', {idClient : $scope.idClient, idSite: $scope.idSite});
					 }, function(response) {
						 $scope.loading = false;
					 });
				 });
			 };

			 /**
			  *
			  */
			 $scope.update = function() {
				 alertService.showSwtQuestion('Actualizar Área', function() {
					 $scope.loading = true;

					 var updateModel = {
							 name: $scope.area.name,
							 description: $scope.area.description,
							 idType: $scope.area.type.selected[0].id
					 };

					 clientService.updatedClientArea($scope.idClient, $scope.idSite, $scope.idArea, updateModel).then(function(response) {
						 $scope.loading = false;
						 alertService.showSuccess('Área actualizada satisfactoriamente');
						 $state.go('home.clientAreas', {idClient : $scope.idClient, idSite: $scope.idSite});
					 }, function(response) {
						 $scope.loading = false;
					 });
				 });
			 };

			 if ($scope.operationType == 'update') {
				 $scope.load($scope.idClient, $scope.idSite, $scope.idArea);
			 }

		} ]);


